var map = {
	"./CaptionAward": 29,
	"./CaptionAward.jsx": 29,
	"./CaptionAwardForm": 30,
	"./CaptionAwardForm.jsx": 30,
	"./CaptionAwards": 58,
	"./CaptionAwards.jsx": 58,
	"./ForumComment": 31,
	"./ForumComment.jsx": 31,
	"./ForumCommentForm": 20,
	"./ForumCommentForm.jsx": 20,
	"./ForumCommentHideConfirmation": 32,
	"./ForumCommentHideConfirmation.jsx": 32,
	"./ForumComments": 19,
	"./ForumComments.jsx": 19,
	"./ForumNotification": 34,
	"./ForumNotification.jsx": 34,
	"./ForumNotifications": 35,
	"./ForumNotifications.jsx": 35,
	"./ForumPost": 59,
	"./ForumPost.jsx": 59,
	"./ForumReportReason": 33,
	"./ForumReportReason.jsx": 33,
	"./ForumReportSubmission": 21,
	"./ForumReportSubmission.jsx": 21,
	"./Navbar": 60,
	"./Navbar.jsx": 60,
	"./Reactions": 18,
	"./Reactions.jsx": 18,
	"./ResourceLink": 37,
	"./ResourceLink.jsx": 37,
	"./ResourceLinkForm": 41,
	"./ResourceLinkForm.jsx": 41,
	"./ResourceLinks": 65,
	"./ResourceLinks.jsx": 65,
	"./Search": 36,
	"./Search.jsx": 36,
	"./SearchSuggestion": 14,
	"./SearchSuggestion.jsx": 14,
	"./ShowPerformanceForm": 68,
	"./ShowPerformanceForm.jsx": 68,
	"./ShowStaffMember": 39,
	"./ShowStaffMember.jsx": 39,
	"./ShowStaffMemberForm": 40,
	"./ShowStaffMemberForm.jsx": 40,
	"./ShowStaffMembers": 67,
	"./ShowStaffMembers.jsx": 67,
	"./UserLink": 17,
	"./UserLink.jsx": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;